React = require 'react'
{ Component, PropTypes } = React
{ Glyphicon } = require 'react-bootstrap'
require '../../styles/spin'

class InnerGlyphicon extends Component
	@propTypes:
		glyph: PropTypes.string
		spin: PropTypes.bool

	render: =>
		glyph = @props.glyph ? 'ok'
		glyph = 'refresh' if @props.spin
		className = if @props.spin then 'glyphicon-spin' else ''

		React.createElement("span", null,
			React.createElement(Glyphicon, {"glyph": (glyph), "className": (className)}), """
\t\t\t  
""")

module.exports = InnerGlyphicon



// WEBPACK FOOTER //
// ./~/cjsx-loader!./frontend/olos/js/components/InnerGlyphicon.cjsx